import ResetPasswordBody from "@/components/landing/auth/ResetPasswordBody";

export default function ResetPasswordPage() {
  return <ResetPasswordBody />;
}
